import { RENDERER_CONFIG } from '@/configs/rendererConfig';
import { ProjectRenderer } from './ProjectRenderer';
import * as THREE from 'three';

export class LightController {
	private directionalLight = new THREE.DirectionalLight(
		RENDERER_CONFIG.LIGHTS_COLOR,
		0.8
	);

	constructor(private renderer: ProjectRenderer) {
		this.renderer = renderer;
		this.init();
	}

	private init() {
		this.directionalLight.position.set(0, 100, 5);
		this.directionalLight.castShadow = true;

		this.directionalLight.shadow.mapSize.width = 1024;
		this.directionalLight.shadow.mapSize.height = 1024;

		this.renderer.scene.add(this.directionalLight);

		if (import.meta.env.DEV)
			this.renderer.scene.add(
				new THREE.DirectionalLightHelper(this.directionalLight, 5, 0xff0000)
			);
	}
}
